import { SvgIcon } from "@mui/material";

function IconExcel(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 48">
      <path
        fill="#185C37"
        d="M41,8H25V40H41c1.66,0,3-1.34,3-3V11C44,9.34,42.66,8,41,8z"
      />
      <path
        fill="#21A366"
        d="M25,8l8,8v24l-8,8H9c-1.66,0-3-1.34-3-3V11c0-1.66,1.34-3,3-3H25z"
      />
      <path
        fill="#107C41"
        d="M33,16H25V8L33,16z"
      />
      <path
        fill="#fff"
        d="M20.27,29.53l2.89-5.37L20.27,19h2.51l1.48,3.35c0.22,0.49,0.39,0.89,0.5,1.2h0.04
           c0.16-0.41,0.33-0.8,0.52-1.17L26.8,19h2.37l-2.9,5.12l2.98,5.41h-2.52l-1.63-3.52c-0.09-0.2-0.16-0.37-0.21-0.52h-0.03
           c-0.05,0.16-0.12,0.34-0.21,0.52l-1.63,3.52H20.27z"
      />
    </SvgIcon>
  );
}

export default IconExcel;
